import { Button, Col, Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { FormProvider } from "react-hook-form";
import { useSelector } from "react-redux";

import { AdminMenuLayout } from "../../../shared/components";
import { ModalIpAccessRules } from "../../../shared/components/ui/modals/ModalIpAccessRules";
import { WrapperCardIpAccessRules } from "./styled";
import { TableIpAccessRules } from "./TableIpAccessRules";
import { selectModalIpAccessRules } from "../../../redux/selectors/ipAccessRules.selectors";
import { useIpAccessRules } from "../hook";

export const IpAccessRules = () => {
  const modalIpAccessRules = useSelector(selectModalIpAccessRules);
  const {
    isUpdateIpAccessRules,
    formMethodsCreate,
    formMethodsUpdate,
    changeModalIpAccessRulesState,
    openCreateWithIp,
  } = useIpAccessRules();

  return (
    <AdminMenuLayout pageDescription="Seguridad IPs" title="Seguridad / IPs">
      <WrapperCardIpAccessRules>
        <Row
          gutter={[8, 8]}
          style={{
            padding: "10px",
            width: "100%",
          }}
        >
          <Col
            span={24}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              gap: 8,
            }}
          >
            <Button
              type="default"
              shape="round"
              size="large"
              onClick={() => openCreateWithIp("", "allow")}
            >
              Agregar a lista blanca
            </Button>
            <Button
              type="primary"
              shape="round"
              icon={<PlusOutlined />}
              size="large"
              onClick={() => openCreateWithIp("", "block")}
            >
              Bloquear IP
            </Button>
          </Col>
        </Row>
        <TableIpAccessRules />
        {modalIpAccessRules && isUpdateIpAccessRules && (
          <FormProvider {...formMethodsUpdate}>
            <ModalIpAccessRules />
          </FormProvider>
        )}
        {modalIpAccessRules && !isUpdateIpAccessRules && (
          <FormProvider {...formMethodsCreate}>
            <ModalIpAccessRules />
          </FormProvider>
        )}
      </WrapperCardIpAccessRules>
    </AdminMenuLayout>
  );
};
